import { Mail, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200/70 dark:border-zinc-800/60 bg-white dark:bg-zinc-950" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="h-9 w-9 rounded-xl bg-white dark:bg-zinc-900 border border-slate-200 dark:border-zinc-800 flex items-center justify-center overflow-hidden">
                <img src="/arrnode-logo.png" alt="Arrnode Prep" className="h-7 w-7 object-contain dark:invert" />
              </div>
              <span className="font-heading font-bold text-lg text-slate-900 dark:text-white">
                Arrnode <span className="text-indigo-600 dark:text-indigo-400">Prep</span>
              </span>
            </div>
            <p className="text-sm text-slate-600 dark:text-zinc-400 leading-relaxed">
              A productivity system for serious JEE and NEET aspirants. No lectures. No distractions. Just the tools you need to stay consistent and improve every day.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-slate-500 dark:text-zinc-500 mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5">
              {[
                { l: "Features", h: "#features" },
                { l: "Plan", h: "#buy" },
                { l: "FAQ", h: "#faq" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    data-testid={`footer-link-${i.l.toLowerCase()}`}
                    className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  >
                    {i.l}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/login"
                  data-testid="footer-link-login"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                >
                  Login
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-link-privacy"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-link-terms"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                >
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-slate-500 dark:text-zinc-500 mb-4">
              Contact
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="mailto:arrnodeprep@gmail.com"
                  data-testid="footer-email"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors inline-flex items-center gap-2"
                >
                  <Mail className="h-3.5 w-3.5" /> arrnodeprep@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/arrnodeprep"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="text-sm text-slate-600 dark:text-zinc-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors inline-flex items-center gap-2"
                >
                  <Instagram className="h-3.5 w-3.5" /> @arrnodeprep
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200/70 dark:border-zinc-800/60">
          <p className="text-xs text-slate-500 dark:text-zinc-500 leading-relaxed max-w-3xl">
            Arrnode Prep does not provide lectures or study content. It provides productivity tools to help students plan, track, analyze, and improve their preparation.
          </p>
          <p className="text-xs text-slate-500 dark:text-zinc-500 mt-3">
            © {new Date().getFullYear()} Arrnode Prep. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
